import { render } from "./AddAccountOrUserToProject.vue?vue&type=template&id=7594b565&scoped=true"
import script from "./AddAccountOrUserToProject.vue?vue&type=script&lang=js"
export * from "./AddAccountOrUserToProject.vue?vue&type=script&lang=js"

import "./AddAccountOrUserToProject.vue?vue&type=style&index=0&id=7594b565&lang=scss&scoped=true"

import exportComponent from "/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7594b565"]])

export default __exports__